import styled from 'styled-components';
export const Container = styled.div `
  position: relative;
  ${({ maxContentWidth, fluid }) => fluid ? `width: 100%` : `max-width: ${maxContentWidth || '90rem'}`};
  padding-right: 1rem;
  padding-left: 1rem;
  margin: 0 auto;
  box-sizing: border-box;

  @media ${({ theme }) => theme.device.medium} {
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }
`;
